// Upload drawer shell (transcripts.md, UI-LAW §4a): the multi-section upload
// form moved out of its header Popover into a right Drawer addressed by
// `?upload=1`. The form mounts only while open (Drawer renders null closed),
// so refresh reopens an empty drawer — draft form state is never URL state.

import type { TranscriptUploadSubmit } from "../../lib/utteranceDraft";
import { Drawer } from "../../ui";
import { TranscriptUploadForm } from "./TranscriptUploadForm";

export interface TranscriptUploadDrawerProps {
  isOpen: boolean;
  // Clears `?upload` (replace) — both on dismiss and on submit success.
  onClose: () => void;
  onSubmit: TranscriptUploadSubmit;
}

export function TranscriptUploadDrawer({
  isOpen,
  onClose,
  onSubmit,
}: TranscriptUploadDrawerProps) {
  return (
    <Drawer
      ariaLabel="Upload transcript"
      isOpen={isOpen}
      size="lg"
      onDismiss={onClose}
    >
      <TranscriptUploadForm onSubmit={onSubmit} onSuccess={onClose} />
    </Drawer>
  );
}
